import { Form, Modal, Button } from 'react-bootstrap';

import { useAppDispatch } from '../../store/hooks';
import { handleSuccess } from '../../utility/helpers';
import { deleteTier } from '../../store/features/admin';

const DeleteTier = ({
    showDeleteTier,
    deleteTierId,
    setShowDeleteTier,
    refreshTiersList
}: any) => {
    const dispatch = useAppDispatch();

    const handleDeleteTier = () => {
        dispatch(deleteTier(deleteTierId))
        .unwrap()
        .then((res: any) => {
            handleSuccess(res?.detail || 'Tier deleted successfully.');
            refreshTiersList();
            setShowDeleteTier(false);
        })
        .catch((error: any) => {
            console.info('Error deleting tier:', error);
        });
    };
    return (
        <>
            < Modal show={showDeleteTier}
                    dialogClassName="modal-236 top-right-modal modal-dialog-centered "
                    className="confirmation-modal sign-up-modal"
            >
                <Modal.Body>
                    <h4 className="modal-head modal-head-medium">Delete Plan</h4>
                    <p className='modal-subhead'>Are you sure you want to delete this plan?</p>
                    <div className='form-wrap'>
                        <Form className="full-width-form">
                            <div className="sign-btn-wrapper tier-btn-wrap">

                                <Button variant="primary" onClick={handleDeleteTier} className="submit-btn scale">
                                    yes, delete
                                </Button>
                                <Button variant="primary" className="btn-cancel not-now-btn" onClick={() => setShowDeleteTier(false)}>
                                    not now
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </ Modal>
        </>
    );
};

export default DeleteTier;
